import { createAction } from 'redux-actions';

import types from './types';

const _loadOrders = createAction(types.LOAD_ORDERS_DATA);
const loadOrders = data => _loadOrders(data);
const setOrdersData = createAction(types.SET_ORDERS_DATA);
const setOfflineOrdersData = createAction(types.SET_OFFLINE_ORDERS_DATA);
const setOfflineApiError = createAction(types.SET_OFFLINE_API_ERROR);
const addOrdersData = createAction(types.ADD_ORDERS_DATA);
const setLoading = createAction(types.SET_LOADING);
const setCode = createAction(types.SET_CODE);
export const getOrders = createAction(types.GET_ORDERS);
export const getOrder = createAction(types.GET_ORDER);
const setOrdersForExtService = createAction(types.SET_ORDERS_FOR_EXT_SERVICE);
const setOrderDetailForExtService = createAction(types.SET_ORDER_DETAIL_FOR_EXT_SERVICE);
const setCurrentPage = createAction(types.SET_CURRENT_PAGE);

export default {
    loadOrders,
    setOrdersData,
    setOfflineOrdersData,
    addOrdersData,
    setLoading,
    setCode,
    getOrders,
    getOrder,
    setOrdersForExtService,
    setOrderDetailForExtService,
    setCurrentPage,
    setOfflineApiError,
};
